import React, {useState} from 'react'
import { firstCharCapitalize } from '../utils/utils'
import './ProductoExpositorLinea.scss'
import './ProductoImplantacionLinea.scss'
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

export const ProductoImplantacionLinea = ({ product, handleClickQuantity }) => {
    // const [product, setProduct] = useState(productObj)

    // const handleClickQuantity = (operacion) => {
    //   if(operacion == 'restar') {
    //     parseInt(product.quantity) > 0 ? product.quantity = parseInt(product.quantity)-1 + '' : ''
    //   }else if(operacion == 'sumar') {
    //     product.quantity = parseInt(product.quantity)+1 + ''
    //   }
    //   // setProduct(product)
    // }

    return (
          <div className="producto-expositor-linea producto-implantacion-linea">
              <div className="img-product">
                  <div className="img">
                      <img src={"/static/imgProducts/" + product.product.Fotografia + "_p.jpg"} onError={(e) => {
                          e.target.onerror = null
                          e.target.src = '/static/img/no-imagen-fansa.png'
                      }} alt="" />
                  </div>
                  <div className="producto item">
                      <div className="titulo"><p>PRODUCTO</p></div>
                      <div className="subtitulo pointer"><p>{firstCharCapitalize(product.product.Descripcion)}</p></div>
                  </div>
              </div>
              <div className="unidades item">
                <div className="quantity-div">
                    <Fab color="primary" size="small">
                      <RemoveIcon onClick={() => { handleClickQuantity('restar')}}/>
                    </Fab>
                    <div className="subtitulo"><p>{product.quantity} un</p></div>
                    <Fab color="primary" size="small">
                      <AddIcon onClick={() => { handleClickQuantity('sumar') }}/>
                    </Fab>
                </div>
              </div>
          </div>
    )
}